import React from "react";
import { Table } from "react-bulma-components";
import { Icon, IconText } from "../common/Icon";
import { UilFileUpload, UilPaperclip } from "@iconscout/react-unicons";
import Dropzone from "react-dropzone";
import ProjectSection from "./ProjectSection";

export default function ProjectDocuments({ documents, onDropFiles, onTriggerDelete, onTriggerModal, project }) {
    return (
        <ProjectSection title="Documents" itemCount={ documents.length } noItemsText="No documents yet!"
                        alwaysShowChildren>
            {
                documents.length === 0 ? null : (
                    <Table size="fullwidth">
                        <tbody>
                        {
                            // TODO: There needs to be a way to change the caption
                            documents.map(document => (
                                <tr key={ document.id } className="is-flex">
                                    <td className="is-flex-grow-1">
                                        <IconText color="success" icon={ UilPaperclip }>
                                            { document.caption }
                                        </IconText>
                                    </td>
                                    <td>
                                        <a download={ document.file } href={ document.file }>
                                            Download
                                        </a>
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                )
            }

            <Dropzone onDrop={ files => onDropFiles('documents', files) }>
                { ({ getRootProps, getInputProps }) => (
                    <section className="dropzone my-5">
                        <div { ...getRootProps() }>
                            <input { ...getInputProps() } />

                            <div className="is-size-2">
                                <Icon icon={ UilFileUpload } size={ 48 }/>
                            </div>

                            Drop documents here, or click to upload.
                        </div>
                    </section>
                ) }
            </Dropzone>
        </ProjectSection>
    );
}